import { render, staticRenderFns } from "./PopupLayer.vue?vue&type=template&id=7767e060&scoped=true&"
import script from "./PopupLayer.vue?vue&type=script&lang=js&"
export * from "./PopupLayer.vue?vue&type=script&lang=js&"
import style0 from "./PopupLayer.vue?vue&type=style&index=0&id=7767e060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7767e060",
  null
  
)

export default component.exports